import React from 'react';
import BusinessFinancialReportPage from './BusinessFinancialReportPage';

export default function ReportDailyPage(props) {
  return <BusinessFinancialReportPage {...props} initialPeriod="day" />;
}
